import { createStore } from "vuex";

export default createStore({
  state: {
    projets: [
      {
        title: "PRODIJ-AZOLI",
        img: require("../assets/img/projects/prodij-3.png"),
        link: "https://prodij-fnm.com/",
        description: "Digital tracking platform for the payment of subsidies to PRODIJ beneficiaries",
        images: [require("../assets/img/projects/prodij-3.png"), require("../assets/img/projects/prodij-2.png"), require("../assets/img/projects/prodij-1.jpeg"), require("../assets/img/projects/prodij-4.png")
        ],
      },
      {
        title: "MTN ONBOARDING",
        img: require("../assets/img/mtn.webp"),
        link: "https://mtn-onboarding.opensi.co/",
        description: "A platform for ordering MTN merchant SIM cards.",
        images: [require("../assets/img/projects/mtn1.png"), require("../assets/img/projects/mtn2.png")],
      },
      {
        title: "LOCAPRO",
        img: require("../assets/img/projects/loca1.jpg"),
        link: "https://app-staging.locapro.ci/",
        description: "Platform for apartment and tenant management",
        images: [
          require("../assets/img/projects/loca1.jpg"),
          require("../assets/img/projects/loca2.jpg"),
          require("../assets/img/projects/loca3.jpg"),
        ],
      },
      {
        title: "Web App BeninRoots",
        img: require("../assets/img/projects/bn1.png"),
        link: "https://www.beninroots.bj/",
        description: "Cultural platform for discovering Benin's heritage.",
        images: [require("../assets/img/projects/bn1.png")],
      },
      {
        title: "Novasend Business",
        img: require("../assets/img/projects/np1.jpg"),
        link: "https://portal-staging.novasend.app/",
        description:
          "Transfer, withdrawal, and portfolio management platform for businesses",
        images: [
          require("../assets/img/projects/np1.jpg"),
          require("../assets/img/projects/np2.jpg"),
          require("../assets/img/projects/np3.jpg"),
        ],
      },
      {
        title: "E-Commerce Sneakers",
        img: require("../assets/img/projects/js.png"),
        link: "https://jordan-sneakers.vercel.app",
        description: "Platform for ordering sneakers Air-Jordan.",
        images: [require("../assets/img/projects/js.png")],
      },
      {
        title: "Nutritionist",
        img: require("../assets/img/projects/nutri.png"),
        link: "https://nutritioniste.vercel.app/",
        description: "Website for a nutrition platform.",
        images: [require("../assets/img/projects/nutri.png")],
      },
      {
        title: "Novasend Website",
        img: require("../assets/img/projects/nb1.png"),
        link: "https://novasend.app/",
        description: "Website for Novasend marketing platform.",
        images: [
          require("../assets/img/projects/nb1.png"),
          require("../assets/img/projects/nb2.jpg"),
        ],
      },

      {
        title: "Movlite",
        img: require("../assets/img/projects/movlite1.png"),
        link: "https://movlite.netlify.app/",
        description: "Movies and series streaming powered by Movie Database.",
        images: [
          require("../assets/img/projects/movlite1.png"),
          require("../assets/img/projects/movlite2.png"),
          require("../assets/img/projects/movlite3.png"),
        ],
      },
      // {
      //   title: "RTFKT x NIKE",
      //   img: require("../assets/img/rtfkt.png"),
      //   link: "https://rtfkt-nike.vercel.app/",
      //   description:
      //   "Product overview of the collaboration between RTFKT & NIKE.",

      //   images: [require("../assets/img/rtfkt.png")],
      // },

      {
        title: "Instagram (Apple Vision Pro)",
        img: require("../assets/img/instagram.png"),
        link: "https://glass-insta.netlify.app/",
        description: "Example of Instagram interface on Apple Vision Pro.",
        images: [require("../assets/img/instagram.png")],
      },
      {
        title: "Ecom Academy",
        img: require("../assets/img/ecom.webp"),
        link: "https://ecom-academy.netlify.app/",
        description: "Landing page for Ecom Academy platform.",
      },
      // {
      //   title: "Arusa Website",
      //   img: require("../assets/img/arusa.png"),
      //   link: "https://areso.vercel.app/",
      //   description: "Landing page for a site e-commerce ."
      // },

      // {
      //   title: "Lamborghini Gallardo",
      //   img: require("../assets/img/lambo.webp"),
      //   link: "https://gallardo-tau.vercel.app/",
      //   description: "Website for the Lamborghini Gallardo.",
      //   images: [
      //     require("../assets/img/projects/gallardo1.png"),
      //     require("../assets/img/projects/gallardo2.png"),
      //     require("../assets/img/projects/gallardo3.png"),
      //   ],
      // },
      // {
      //   title: "Shoes Website",
      //   img: require("../assets/img/dunk.png"),
      //   link: "https://dunk-nine.vercel.app/",
      //   description: "Landing page for a site shoes nike .",
      // },
      // {
      //   title: "Artist quote",
      //   img: require("../assets/img/dinos.jpg"),
      //   link: "https://dinospunchs.netlify.app/",
      //   description:
      //     "Check out some and saved as images of the artist Dinos' lyrics.",
      // },
      // {
      //   title: "EditPic",
      //   img: require("../assets/img/editpic.jpg"),
      //   link: "https://editpic.netlify.app/",
      //   description: "Modify images by changing brightness, saturation, color and more. "
      // },
      // {
      //   title: "Music Player",
      //   img: require("../assets/img/player.png"),
      //   link: "https://loicfarele.netlify.app/music",
      //   description: "Simple music player."
      // },
      // {
      //   title: "Weather App",
      //   img: require("../assets/img/meteo.jpg"),
      //   link: "https://loicfarele.netlify.app/meteo",
      //   description: "Display the temperature of your regions and more."
      // },
      // {
      //   title: "Memory Game",
      //   img: require("../assets/img/memory.jpg"),
      //   link: "https://loicfarele.netlify.app/memory",
      //   description: "Find pairs of images with as few attempts as possible."
      // },
      // {
      //   title: "Note App",
      //   img: require("../assets/img/note.png"),
      //   link: "https://loicfarele.netlify.app/note",
      //   description: "Makes it easy to take notes."
      // },
      // {
      //   title: "Do something",
      //   img: require("../assets/img/bored.jpg"),
      //   link: "https://loicfarele.netlify.app/bored",
      //   description: "Find things to do if you're bored."
      // },
      // {
      //   title: "Scanneur de code QR",
      //   img: require("../assets/img/rqr.png"),
      //   link: "https://loicfarele.netlify.app/rqr",
      //   description: "Scanne les codes QR pour en ressorti les informations 😇."
      // },
      // {
      //   title: "Application de quizz",
      //   img: require("../assets/img/quizz.png"),
      //   link: "https://loicfarele.netlify.app/quiz",
      // },
      // {
      //   title: "Générateur de code QR",
      //   img: require("../assets/img/gqr.jpg"),
      //   link: "https://loicfarele.netlify.app/gqr",
      //   description: "Génère des codes QR en fonction des données entrées 😇."
      // },
      // {
      //   title: "IP Info",
      //   img: require("../assets/img/ip.jpg"),
      //   link: "https://loicfarele.netlify.app/ipinfo",
      //   description: "L'application donne des informations plutôt basiques sur des adresses IP entrées par l'utilisateur. L'application peut prendre directement votre adresse IP si vous le souhaité 😇."
      // },
      // {
      //   title: "Site de portfolio",
      //   img: require("../assets/img/portfolio.png"),
      //   link: "https://loicfarel.netlify.app",
      //   description: "Ceci est mon site portfolio, si je ne me trompe pas vous le visité actuellement 😉."
      // },
      // {
      //   title: "Générateur de citation",
      //   img: require("../assets/img/quote.jpg"),
      //   link: "https://loicfarele.netlify.app/quote",
      //   description: "L'application génère des citations aléatoires, vous pouvez \"likez\" pour une lecture plus tard 😉. "
      // },
      // {
      //   title: "Calculatrice",
      //   img: require("../assets/img/calculatrice.png"),
      //   link: "https://loicfarele.netlify.app/calculatrice",
      //   description: "En ce qui concerne les fonctionnlités vous connaissez déja la chanson 😅, ça permet de faire des calculs."
      // },
      // {
      //   title: "A venir",
      //   img: require("../assets/img/work.png"),
      //   link: "#",
      // },
    ],

    projetsFront: [],

    displayModal: false,

    showLoader: true,
  },

  getters: {
    projets(state) {
      return state.projets;
    },

    projetsFront(state) {
      return state.projetsFront;
    },

    displayModal(state) {
      return state.displayModal;
    },

    showLoader(state) {
      return state.showLoader;
    },
  },

  mutations: {
    setDisplayModal(state, display) {
      state.showLoader = display;
    },

    setShowLoader(state, display) {
      state.showLoader = display;
    },
  },
  actions: {
    hidenLoader({ commit }) {
      setTimeout(() => {
        commit("setShowLoader", false);
      }, 2300);
    },
  },
  modules: {},
});
